<template>
  <v-row>
    <v-col cols="12">
      <div style="min-height: 4px">
        <v-progress-linear
          v-if="loading"
          indeterminate
        />
      </div>

      <v-card>
        <v-card-title> Filtrar </v-card-title>
        <v-form
          ref="formRef"
          class="multi-col-validation"
          @submit.prevent="filtrar"
        >
          <v-row class="px-2 ma-0">
            <v-col
              cols="12"
              sm="6"
              md="3"
            >
              <VSelect
                v-model="filasSelecionadasIds"
                :items="filasDisponiveis"
                item-text="nome"
                item-value="id"
                label="Filas"
                chips
                multiple
                dense
                outlined
                clearable
              />
            </v-col>

            <v-col
              cols="12"
              sm="6"
              md="2"
            >
              <VSelect
                v-model="canalSelecionadoId"
                :items="canaisDisponiveis"
                item-text="nome"
                item-value="id"
                label="Canal"
                dense
                outlined
                clearable
              />
            </v-col>

            <v-col
              cols="12"
              sm="6"
              md="2"
            >
              <VSelect
                v-model="tipoSolicitacaoSelecionadoId"
                :items="tiposSolicitacaoDisponiveis"
                item-text="nome"
                item-value="id"
                label="Tipo de solicitação"
                dense
                outlined
                clearable
              />
            </v-col>

            <v-col
              cols="12"
              sm="6"
              md="2"
            >
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateFormatted"
                    label="Período de:"
                    outlined
                    dense
                    clearable
                    color="primary"
                    v-bind="attrs"
                    :rules="[validators.required]"
                    v-on="on"
                    @blur="filtroPeriodoInicio = parseDate(dateFormatted)"
                  />
                </template>

                <v-date-picker
                  v-model="filtroPeriodoInicio"
                  no-title
                  color="primary"
                  locale="pt-br"
                  @input="menu1 = false"
                />
              </v-menu>
            </v-col>

            <v-col
              cols="12"
              sm="6"
              md="2"
            >
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="computedDateFormatted"
                    label="Período até:"
                    dense
                    outlined
                    clearable
                    color="primary"
                    v-bind="attrs"
                    :rules="[validators.required]"
                    v-on="on"
                    @blur="filtroPeriodoFim = parseDate(computedDateFormatted)"
                  />
                </template>

                <v-date-picker
                  v-model="filtroPeriodoFim"
                  no-title
                  color="primary"
                  locale="pt-br"
                  @input="menu2 = false"
                />
              </v-menu>
            </v-col>
          </v-row>

          <v-row class="px-2 ma-0">
            <v-col
              cols="12"
              class="d-flex"
            >
              <v-btn
                color="primary"
                :loading="loadingButton"
                class="mr-3"
                type="submit"
              >
                <span>Filtrar</span>
              </v-btn>

              <v-btn
                v-if="filtragemFeita"
                color="primary"
                @click="downloadExcel"
              >
                <v-icon left>
                  {{ icons.mdiFileExcelOutline }}
                </v-icon>
                <span>Exportar</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-col>

    <div style="min-height: 4px">
      <v-expand-transition>
        <v-progress-linear
          v-if="loadingComponentes"
          indeterminate
        />
      </v-expand-transition>
    </div>

    <v-col cols="12">
      <v-expand-transition>
        <div
          v-if="filtragemFeita"
          class="sla-counters"
        >
          <counter
            :loading="loadingComponentes"
            :counters="counters"
          />
        </div>
      </v-expand-transition>
    </v-col>

    <v-col cols="12">
      <v-expand-transition>
        <v-card
          v-if="filtragemFeita"
          flat
        >
          <v-card-title>Ranking de tickets com SLA descumprido</v-card-title>
          <v-data-table
            no-data-text="Nenhum descumprimento de SLA no período"
            :headers="headersDescumprimentos"
            :items="descumprimentos"
            :loading="loadingComponentes"
            :footer-props="{
              'items-per-page-text':'Linhas por página',
              'page-text': '{0}-{1} de {2}',
            }"
          >
            <template #[`item.minutosAtraso`]="{ item }">
              <span class="error--text font-weight-semibold">{{ item.minutosAtraso }}</span>
            </template>

            <template #[`item.dataConclusao`]="{ item }">
              {{ item.dataConclusao ? formatarData(item.dataConclusao) : 'Ainda em aberto' }}
            </template>

            <template #[`item.dataLimite`]="{ item }">
              {{ formatarData(item.dataLimite) }}
            </template>

            <template #[`item.dataInicio`]="{ item }">
              {{ formatarData(item.dataInicio) }}
            </template>
          </v-data-table>
        </v-card>
      </v-expand-transition>
    </v-col>
  </v-row>
</template>

<script>
import Vue from 'vue'
import {
  ref, computed, watch, onMounted,
} from '@vue/composition-api'
import {
  mdiAbacus, mdiCalendar, mdiFileExcelOutline, mdiPercent, mdiClockOutline, mdiAlertOctagon,
} from '@mdi/js'
import { required } from '@core/utils/validation'
import ExcelJS from 'exceljs'
import * as FileSaver from 'file-saver'
import Counter from '@/components/counter/Counter.vue'
import FilaService from '@/services/modules/FilaService'
import CanalService from '@/services/modules/CanalService'
import TipoSolicitacaoService from '@/services/modules/TipoSolicitacaoService'
import RelatorioService from '@/services/modules/RelatorioService'
import useForm from '@/composables/useForm'
import { getDataFinalMes, getDataInicialMes } from '@/utils/dateTime'

export default {
  components: {
    Counter,
  },

  setup() {
    const filasDisponiveis = ref([])
    const filasSelecionadasIds = ref([])
    const canaisDisponiveis = ref([])
    const canalSelecionadoId = ref(null)
    const tiposSolicitacaoDisponiveis = ref([])
    const tipoSolicitacaoSelecionadoId = ref(null)
    const descumprimentos = ref([])

    const loading = ref(true)
    const loadingComponentes = ref(false)
    const loadingButton = ref(false)
    const filtragemFeita = ref(false)

    const { formRef, validateForm } = useForm()

    const filtroPeriodoInicio = ref(getDataInicialMes())
    const filtroPeriodoFim = ref(getDataFinalMes())
    const menu1 = ref(false)
    const menu2 = ref(false)

    function formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')

      return `${day}/${month}/${year}`
    }

    function parseDate(date) {
      if (!date) return null
      const [day, month, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }

    function formatarData(data) {
      return new Date(data).toLocaleString('pt-BR')
    }

    function formatarMinutos(minutos) {
      if (minutos == null) return '-'
      const horas = Math.floor(minutos / 60)
      const min = minutos % 60

      return horas > 0 ? `${horas}h ${min}min` : `${min}min`
    }

    let dateFormatted = computed(() => formatDate(filtroPeriodoInicio.value))
    let computedDateFormatted = computed(() => formatDate(filtroPeriodoFim.value))

    watch(filtroPeriodoInicio, () => {
      dateFormatted = formatDate(filtroPeriodoInicio.value)
    })

    watch(filtroPeriodoFim, () => {
      computedDateFormatted = formatDate(filtroPeriodoFim.value)
    })

    onMounted(async () => {
      try {
        loading.value = true
        const [filas, canais, tiposSolicitacao] = await Promise.all([
          FilaService.getFilasQuePossuemSlasConfigurados(),
          CanalService.get(),
          TipoSolicitacaoService.get().then(res => res.data.data),
        ])
        filasDisponiveis.value = filas
        canaisDisponiveis.value = canais
        tiposSolicitacaoDisponiveis.value = tiposSolicitacao
      } finally {
        loading.value = false
      }
    })

    const headersDescumprimentos = [
      { text: 'Protocolo', value: 'protocolo' },
      { text: 'Fila', value: 'filaNome' },
      { text: 'Tipo de SLA', value: 'tipoSlaNome' },
      { text: 'Atendente', value: 'atendenteNome' },
      { text: 'Início', value: 'dataInicio' },
      { text: 'Limite', value: 'dataLimite' },
      { text: 'Conclusão', value: 'dataConclusao' },
      { text: 'Atraso', value: 'minutosAtraso' },
    ]

    function counterIndicador(titulo, indicador, corIcone, icone) {
      return {
        title: titulo,
        quantity: indicador.percentualCumprimento == null ? 'Sem dados' : `${indicador.percentualCumprimento}%`,
        icon: { color: corIcone, shape: icone },
      }
    }

    const counters = ref([
      {
        title: 'Total tickets no período',
        quantity: 0,
        icon: { color: 'primary', shape: mdiAbacus },
      },
      {
        title: 'Cumprimento SLA Primeira Resposta',
        quantity: 'Sem dados',
        icon: { color: 'success', shape: mdiPercent },
      },
      {
        title: 'Tempo médio Primeira Resposta',
        quantity: '-',
        icon: { color: 'info', shape: mdiClockOutline },
      },
      {
        title: 'Cumprimento SLA Finalização',
        quantity: 'Sem dados',
        icon: { color: 'success', shape: mdiPercent },
      },
      {
        title: 'Tempo médio Finalização',
        quantity: '-',
        icon: { color: 'info', shape: mdiClockOutline },
      },
      {
        title: 'Tickets com SLA descumprido',
        quantity: 0,
        icon: { color: 'error', shape: mdiAlertOctagon },
      },
    ])

    function buildFiltroBase() {
      return {
        filaIds: filasSelecionadasIds.value,
        canalId: canalSelecionadoId.value,
        tipoSolicitacaoId: tipoSolicitacaoSelecionadoId.value,
        dataInicio: filtroPeriodoInicio.value,
        dataFim: filtroPeriodoFim.value,
      }
    }

    async function getSlas() {
      const filtroBase = buildFiltroBase()

      const [relatorio, listaDescumprimentos] = await Promise.all([
        RelatorioService.getRelatorioSla(filtroBase),
        RelatorioService.getRelatorioSlaDescumprimentos(filtroBase),
      ])

      const { qtdTicketsNoPeriodo, primeiraResposta, finalizacao } = relatorio

      counters.value[0].quantity = qtdTicketsNoPeriodo ?? 0
      counters.value[1] = { ...counterIndicador('Cumprimento SLA Primeira Resposta', primeiraResposta, 'success', mdiPercent) }
      counters.value[2].quantity = primeiraResposta.tempoMedioRealizadoMinutos == null ? '-' : formatarMinutos(Math.round(primeiraResposta.tempoMedioRealizadoMinutos))
      counters.value[3] = { ...counterIndicador('Cumprimento SLA Finalização', finalizacao, 'success', mdiPercent) }
      counters.value[4].quantity = finalizacao.tempoMedioRealizadoMinutos == null ? '-' : formatarMinutos(Math.round(finalizacao.tempoMedioRealizadoMinutos))
      counters.value[5].quantity = primeiraResposta.qtdDescumpridos + finalizacao.qtdDescumpridos

      descumprimentos.value = listaDescumprimentos
    }

    async function filtrar() {
      if (Date.parse(filtroPeriodoFim.value) < Date.parse(filtroPeriodoInicio.value)) {
        Vue.$toast.warning('O periódo final deve ser menor que o periódo inicial!', {
          timeout: false,
        })
        loadingButton.value = false
        return
      }

      const diferenca = Date.parse(filtroPeriodoFim.value) - Date.parse(filtroPeriodoInicio.value)
      const diferencaDias = diferenca / (1000 * 3600 * 24)
      if (diferencaDias >= 366) {
        Vue.$toast.warning('A diferença entre as datas deve ser de no máximo 365 dias!', {
          timeout: false,
        })
        loadingButton.value = false
        return
      }

      if (loadingButton.value) return
      if (validateForm()) {
        loadingButton.value = true
        loadingComponentes.value = true
        await getSlas()
        filtragemFeita.value = true
      }

      loadingComponentes.value = false
      loadingButton.value = false
    }

    async function downloadExcel() {
      const workbook = new ExcelJS.Workbook()

      const indicadoresSheet = workbook.addWorksheet('Indicadores')
      indicadoresSheet.addTable({
        name: 'Indicadores',
        ref: 'A1',
        headerRow: true,
        style: { theme: 'TableStyleMedium2', showRowStripes: false },
        columns: [
          { name: 'Indicador', filterButton: false },
          { name: 'Primeira Resposta', filterButton: false },
          { name: 'Finalização', filterButton: false },
        ],
        rows: [
          ['% Cumprimento', counters.value[1].quantity, counters.value[3].quantity],
          ['Tempo médio', counters.value[2].quantity, counters.value[4].quantity],
        ],
      })
      indicadoresSheet.getColumn(1).width = 25
      indicadoresSheet.getColumn(2).width = 25
      indicadoresSheet.getColumn(3).width = 25

      const descumprimentosSheet = workbook.addWorksheet('Descumprimentos')
      descumprimentosSheet.addTable({
        name: 'Descumprimentos',
        ref: 'A1',
        headerRow: true,
        style: { theme: 'TableStyleMedium2', showRowStripes: false },
        columns: [
          { name: 'Protocolo', filterButton: true },
          { name: 'Fila', filterButton: true },
          { name: 'Tipo de SLA', filterButton: true },
          { name: 'Atendente', filterButton: true },
          { name: 'Início', filterButton: false },
          { name: 'Limite', filterButton: false },
          { name: 'Conclusão', filterButton: false },
          { name: 'Atraso (min)', filterButton: false },
        ],
        rows: descumprimentos.value.map(v => [
          v.protocolo,
          v.filaNome,
          v.tipoSlaNome,
          v.atendenteNome ?? '-',
          formatarData(v.dataInicio),
          formatarData(v.dataLimite),
          v.dataConclusao ? formatarData(v.dataConclusao) : 'Ainda em aberto',
          v.minutosAtraso,
        ]),
      })
      for (let i = 1; i <= 8; i += 1) {
        descumprimentosSheet.getColumn(i).width = 22
      }

      workbook.xlsx.writeBuffer().then(buffer => {
        const blob = new Blob([buffer], { type: 'application/octet-stream' })
        FileSaver.saveAs(blob, 'RelatorioSla.xlsx')
      })
    }

    return {
      filasDisponiveis,
      filasSelecionadasIds,
      canaisDisponiveis,
      canalSelecionadoId,
      tiposSolicitacaoDisponiveis,
      tipoSolicitacaoSelecionadoId,
      descumprimentos,
      loading,
      loadingComponentes,
      loadingButton,
      filtragemFeita,
      headersDescumprimentos,
      counters,
      formRef,
      filtroPeriodoFim,
      filtroPeriodoInicio,
      dateFormatted,
      menu1,
      menu2,
      computedDateFormatted,
      parseDate,
      formatarData,
      formatarMinutos,
      filtrar,
      downloadExcel,
      icons: { mdiCalendar, mdiFileExcelOutline },
      validators: {
        required,
      },
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';

.sla-counters .v-card {
  height: 100%;
  min-height: 100px;
  display: flex;
  align-items: center;
}
</style>
